import { EVENT_TYPE } from '@/const.js';
import { hooks } from '@/store.js';
import showErrMessage from '@/utils/showErrMessage.js';
import { Drawer, DrawerContent, DrawerBody, Button } from '@heroui/react';
import { useRequest } from 'ahooks';
import { memo, useRef, useState } from 'react';
import isEqual from 'react-fast-compare';
import { toast } from 'sonner';
import { UseAddRoute } from '../AddRoute/index.jsx';
import { UseAddTransport } from '../AddTransport/index.jsx';

function getOrderIdx({
  orderIdx,
  isAppendAdd,
}: {
  orderIdx?: number;
  isAppendAdd?: boolean;
}) {
  return orderIdx || (isAppendAdd ? -new Date() : +new Date());
}

const Inner = memo(
  ({
    date,
    onSuccess,
    isAppendAdd,
    planId,
    onClose,
    orderIdx,
  }: {
    date: string;
    onSuccess: () => void;
    isAppendAdd?: boolean;
    planId: string;
    onClose?: () => void;
    orderIdx?: number;
  }) => {
    const [action, setAction] = useState('搜索地点');
    const actionConfig = EVENT_TYPE.find((i) => i.label === action);
    const inputRef = useRef<HTMLInputElement>(null);
    const [value, setValue] = useState('');
    const addRouteModal = UseAddRoute();
    const addTransportModal = UseAddTransport();

    const client = hooks.useClient();
    const { runAsync, loading } = useRequest(
      async () => {
        if (!date || !planId) throw new Error('参数不全');

        return await client.events.put({
          type: 'custom',
          custom: { title: value },
          date,
          planId,
          orderIdx: getOrderIdx({ orderIdx, isAppendAdd }),
        });
      },
      {
        manual: true,
        onError: showErrMessage,
        onSuccess() {
          toast.success('添加成功');
          onSuccess();
        },
      }
    );

    return (
      <>
        {action === '搜索地点' && (
          <div className=' absolute -top-14 pb-4 px-4 text-[13px] overflow-auto w-full  '>
            <div className='flex w-max'>
              {EVENT_TYPE.filter(
                (i) =>
                  !['搜索地点', '景点', '住宿', '吃喝', '其他'].includes(
                    i.label
                  )
              ).map((item) => {
                return (
                  <span
                    key={item.label}
                    className=' rounded-full flex items-center px-[18px] py-1.5 font-[700] mr-2.5'
                    style={{
                      backgroundColor: item.bgColor,
                      color: item.color,
                    }}
                    onClick={() => {
                      if (item.label === '添加交通') {
                        addTransportModal.show({
                          planId,
                          date,
                          orderIdx: getOrderIdx({ orderIdx, isAppendAdd }),
                        });
                        onClose?.();
                      } else if (item.label === '自定义活动') {
                        setAction(item.label);
                        inputRef.current?.focus();
                      } else if (item.label === '交通或停留') {
                        addRouteModal.show({
                          planId,
                          date,
                          orderIdx: getOrderIdx({ orderIdx, isAppendAdd }),
                        });
                        onClose?.();
                      }
                    }}
                  >
                    <i
                      className={`ic-outline text-lg leading-none! mt-[1px] mr-1  ${item.icon}`}
                    />
                    {item.label}
                  </span>
                );
              })}
            </div>
          </div>
        )}

        <DrawerBody className='pb-safe'>
          <div className=' flex items-center py-2  overflow-hidden '>
            <span
              className='w-11 h-11 text-xl shrink-0 rounded-xl flex items-center justify-center mr-4 text-gray-800'
              style={{
                backgroundColor: actionConfig?.bgColor,
                // color: actionConfig?.color,
              }}
              onClick={() => {
                if (action === '搜索地点') {
                  setAction('自定义活动');
                } else if (action === '自定义活动') {
                  setAction('搜索地点');
                }
                inputRef.current?.focus();
              }}
            >
              <i className={`ic-outline ${actionConfig?.icon}`} />
            </span>
            <div className='flex-grow overflow-hidden mr-3'>
              <input
                placeholder={actionConfig?.label}
                className='text-xl font-bold outline-none '
                ref={inputRef}
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>

            {value?.length ? (
              <Button
                color='primary'
                radius='full'
                className='font-bold text-sm shrink-0 '
                isLoading={loading}
                size='sm'
                onPress={runAsync}
              >
                创建
              </Button>
            ) : null}
          </div>
        </DrawerBody>
      </>
    );
  },
  isEqual
);

export interface IAddEventProps {
  date: string;
  onSuccess?: () => void;
  isAppendAdd?: boolean;
  planId: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  orderIdx?: number;
}
const AddEvent = memo(
  ({
    date,
    isAppendAdd,
    onSuccess,
    planId,
    orderIdx,
    ...props
  }: IAddEventProps) => {
    return (
      <Drawer
        hideCloseButton
        {...props}
        placement='bottom'
        // @ts-ignore type
        classNames={{
          base: 'overflow-visible',
          backdrop: ' bg-white/85',
        }}
      >
        <DrawerContent className='shadow-45-light-up shadow-none rounded-t-[30px]'>
          {(onClose) => (
            <Inner
              onSuccess={() => {
                onSuccess?.();
                onClose();
              }}
              date={date}
              isAppendAdd={isAppendAdd}
              planId={planId}
              onClose={onClose}
              orderIdx={orderIdx}
            />
          )}
        </DrawerContent>
      </Drawer>
    );
  },
  isEqual
);

export default AddEvent;
